import { api_DELETE, api_GET, api_POST, api_POST_files, api_PUT } from './_api';

const destino_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Destino/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Destino/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListModalidadeDestino: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Destino/GetListModalidadeDestino`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Destino/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Destino/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListManejoResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Destino/GetListManejoResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostManejoResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Destino/InsertManejoResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PutManejoResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Destino/UpdateManejoResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    DeleteManejoResiduo: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`Destino/DeleteManejoResiduo/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostDocumentos: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_files("Destino/InsertDocumentosDestino", obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    }
}

export default destino_api;